<template>
    <div class="layout-with-centered-max-width-child">
      <div>
        <div class="reset-form-container-spacing">
          <div class="reset-form-container">
            <div class="heading-container">
              <div class="font-secondary heading">Let's make a new password!</div>
            </div>
            <div class="each-row">
              <div class="left-side">Password</div>
              <div class="right-side">
                <div class="input-box-container">
                  <input :type="passwordInputTypeOne" class="input-box" v-on:focus="resetToButton" v-model="passwordOne" placeholder="New Password">
                  <Fai v-if="showPasswordOne" class="show-password-icon" v-on:click="setHidePasswordOne" :icon="['far', 'eye']"/>
                  <Fai v-else class="show-password-icon" v-on:click="setShowPasswordOne" :icon="['far', 'eye-slash']"/>
                </div>
                <span class="error" v-show="errors.passwordOne">*6 Characters Required</span>
              </div>
            </div>
            <div class="each-row">
              <div class="left-side">Confirm Password</div>
              <div class="right-side">
                <div class="input-box-container">
                  <input :type="passwordInputTypeTwo" class="input-box" v-on:focus="resetToButton" v-model="passwordTwo" placeholder="Repeat Same Password">
                  <Fai v-if="showPasswordTwo" class="show-password-icon" v-on:click="setHidePasswordTwo" :icon="['far', 'eye']"/>
                  <Fai v-else class="show-password-icon" v-on:click="setShowPasswordTwo" :icon="['far', 'eye-slash']"/>
                </div>
                <span class="error" v-show="errors.passwordTwo">*6 Characters Required</span>
              </div>
            </div>
            <div class="each-row">
              <div class="left-side"></div>
              <div class="right-side">
                <span class="error" v-show="!errors.passwordsAreEqual">*Passwords do not match</span>
                <button v-if="passwordChangePristine" class="button pure-button bigmi-red-2-button" v-on:click="sendPasswordResetRequest">Create New Password</button>
                <Loading v-else-if="passwordChangeLoading" class="button"></Loading>
                <span v-else-if="passwordChangeSucceeded" class="button completion-message font-secondary">Password Successfully Changed</span>
                <span v-else-if="passwordChangeFailed" class="button completion-message font-secondary">Oops... Something went wrong, please try again</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {
    GET_BACKEND_URL,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_PRISTINE,
    LOADING_STARTED
  } from "../../services/constants"
    import http from "../../services/axios"

    export default {
      name: "PasswordResetPage",

      //  Give user Indiciation of loading/response

      data(){
        return{
          passwordOne: '',
          passwordTwo: '',
          errors: this.resetErrors(),
          loadingStatus: LOADING_PRISTINE,
          showPasswordOne: false,
          showPasswordTwo: false,
        }
      },

      computed: {
        passwordChangePristine(){
          return this.loadingStatus === LOADING_PRISTINE
        },
        passwordChangeLoading(){
          return this.loadingStatus === LOADING_STARTED
        },
        passwordChangeSucceeded(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        passwordChangeFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        passwordInputTypeOne(){
          return this.showPasswordOne ? "text" : "password"
        },
        passwordInputTypeTwo(){
          return this.showPasswordTwo ? "text" : "password"
        },

      },

      methods: {
        sendPasswordResetRequest(){
          this.errors = this.resetErrors()
          if(this.readyToSubmit()){
            this.loadingStatus = LOADING_STARTED
            let objectToPost = this.buildObjectToPost()
            http.post(this.$store.getters[GET_BACKEND_URL](`user/pass-reset`), objectToPost).then(response => {
              this.loadingStatus = response.data.success ? LOADING_COMPLETED_SUCCESS : LOADING_COMPLETED_FAILURE
            }).catch(err => {
              console.error(err)
              this.loadingStatus = LOADING_COMPLETED_FAILURE
            })
          }
        },
        checkPasswordsSatisfyRequirements(){
          let passwordsAreGood = true
          if(!this.isPasswordGood(this.passwordOne)){
            passwordsAreGood = false
            this.errors.passwordOne = true
          }
          if(!this.isPasswordGood(this.passwordTwo)){
            passwordsAreGood = false
            this.errors.passwordTwo = true
          }
          return passwordsAreGood
        },
        checkPasswordsAreTheSame(){
          let equality = this.passwordOne === this.passwordTwo
          this.errors.passwordsAreEqual = equality
          return equality
        },
        isPasswordGood(password){
          return password.length > 5
        },
        readyToSubmit(){
          return this.checkPasswordsSatisfyRequirements() && this.checkPasswordsAreTheSame()
        },
        resetErrors(){
          return  {
            passwordOne: false,
            passwordTwo: false,
            passwordsAreEqual: true,
          }
        },
        buildObjectToPost(){
          return{
            token: this.$route.params.token,
            newPassword: this.passwordOne,
          }
        },
        resetToButton(){
          if(this.passwordChangeFailed){
            this.loadingStatus = LOADING_PRISTINE
          }
        },
        setHidePasswordOne(){
          this.showPasswordOne = false
        },
        setShowPasswordOne(){
          this.showPasswordOne = true
        },
        setHidePasswordTwo(){
          this.showPasswordTwo = false
        },
        setShowPasswordTwo(){
          this.showPasswordTwo = true
        },
      }
    }
</script>

<style scoped lang="scss">
  @import "../../scss/main";

  .reset-form-container-spacing{
    padding: 3% 5%;
  }

  .reset-form-container{
    width: 140%;
    @media #{$mobile} {
      width: 100%;
    }
  }

  .left-side{
    display: inline-block;
    vertical-align: top;
    width: 20%;
  }

  .right-side{
    display: inline-block;
    width: 30%;
    @media #{$mobile} {
      width: 80%;
    }
  }

  .each-row{
    padding: 5px 0;
  }

  .input-box-container{
    display: flex;
    align-items: center;

    .input-box{
      flex-grow: 1;
      border: $gray-1;
      height: 40px;
      background-color: $gray-1;
      text-indent:10px;
    }

    .show-password-icon{
      align-items: flex-end;
      margin: 0.25em 0 0.25em 0.5em;
      font-size: medium;
      cursor: pointer;
    }
  }

  .error{
    color: red;
  }

  .heading{
    color: $red-2;
    font-size: 20px;
    font-weight: 900;
  }

  .heading-container{
    padding: 3% 0;
  }

  .button{
    float: right;
  }

  .completion-message{
    padding: 1em 0;
    color: $red-2;
    font-size: 16px;
  }

</style>
